<template>
  <v-window-item value="materjalid">
    SIIA TULEB ANDMETE ÜLESLAADIMINE & KONKREETSE SÕNA/LAUSE MUUTMINE
  </v-window-item>
</template>

<script setup lang="ts"></script>

<style scoped></style>
